import React from "react";
import BuyComponent from "../../component/Buy";
import { Wrap } from "./style";

export default function BuyPage() {
  return (
    <Wrap>
      <BuyComponent />
    </Wrap>
  );
}
